var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoney = function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.917,
    d: "M16.294 10.22c-.987-2.443-3.07-4.887-7.18-4.887-5.137 0-6.536 3.574-6.536 5.21 0 1.43.426 4.054 6.216 5.28 5.665 1.198 7.214 3.174 6.949 6.132-.206 2.305-2.546 4.887-6.582 4.703-4.46-.204-6.422-2.652-7.454-4.035M9 4.667V1.334m0 29.333v-3.334"
  })));
};
export default SvgMoney;